import "./Icon.scss";

const Icon = ({className, id, width, height}) => {
  return (
    <svg className={`icon ${className}`} width={width} height={height}>
      <use href={`/icons/sprite.svg#${id}`} />
    </svg>
  );
}

export default Icon;